import { AsyncReturnType } from "type-fest";

import { CampaignService } from "@/services";
import { UseMutationSimpleOptions, useMutation } from "@/services/hooks";

type Variables = Parameters<typeof CampaignService.createGroup>[0];
type Data = AsyncReturnType<typeof CampaignService.createGroup>;
type Error = unknown;

export const useCreateGroup = <TContext = unknown>(
  options?: UseMutationSimpleOptions<Data, Error, Variables, TContext>
) => {
  const result = useMutation<Data, Error, Variables, TContext>(
    CampaignService.createGroup,
    options
  );

  return result;
};
